<!-- 服务项目信息编辑页 -->
<template>
  <div class="edit white">
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <el-form ref="form" :model="form" class="demo-ruleForm" label-width="110px">
             <el-row>
                 <el-col :span="24"><el-form-item label="店员照片：">
                    <el-image
                        class="img"
                        :src="form.headImgUrl"
                        title="点击放大图片"
                        :preview-src-list="srcList"
                        @click="handleClick(form.headImgUrl)"
                    />
                    </el-form-item>
                </el-col>
                 <el-col :span="12"><el-form-item label="姓名：">{{ form.staffName }}</el-form-item></el-col>
                 <el-col :span="12"><el-form-item label="性别：">{{ form.gender == 'male' ? '男' : '女' }}</el-form-item></el-col>
                 <el-col :span="12"><el-form-item label="职位：">{{ form.positionIdCn }}</el-form-item></el-col>
                 <el-col :span="12"><el-form-item label="入职时间：">{{ form.joinTime }}</el-form-item></el-col>
                 <el-col :span="12"><el-form-item label="账号状态：">{{ form.accountStatusCn }}</el-form-item></el-col>
                 <el-col :span="12"><el-form-item label="店员状态：">{{ form.statusCn }}</el-form-item></el-col>
                 <el-col :span="12"><el-form-item label="入职状态：">{{ form.auditStatusCn }}</el-form-item></el-col>
                 <el-col :span="12"><el-form-item label="审核备注：">{{ form.auditRemark }}</el-form-item></el-col>
                 <el-col :span="12"><el-form-item label="店员工号：">{{ form.staffNo }}</el-form-item></el-col>
                 <el-col :span="12"><el-form-item label="手机号码：">{{ form.mobile }}</el-form-item></el-col>
                 <el-col :span="24"><el-form-item label="身份证号码：">{{ form.idCardNo }}</el-form-item></el-col>
                 <el-col :span="12"><el-form-item label="身份证正面：">
                    <el-image
                        class="img"
                        :src="form.idCardFrontUrl"
                        title="点击放大图片"
                        :preview-src-list="srcList"
                        @click="handleClick(form.idCardFrontUrl)"
                    />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                     <el-form-item label="身份证反面：">
                        <el-image
                            class="img"
                            :src="form.idCardBackUrl"
                            title="点击放大图片"
                            :preview-src-list="srcList"
                            @click="handleClick(form.idCardBackUrl)"
                        />
                     </el-form-item>
                 </el-col>
                 
             </el-row>
          </el-form>
        </div>
        <div class="drawer-footer">
          <div class="btns">
            <div class="back el-icon-back" @click="back"></div>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import drawer from "../../../components/common/drawer";
import minxin from "../../../assets/javascript/minxin.js";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  data() {
    return {
      addEditShow: false,
      addEditTitle: "",
      form: {
        id: "",
        staffName: "", //姓名
        gender: "male", //性别 默认男
        positionId: "", //选择职位
        mobile: "", //联系电话
        verifyCode: "", //验证码
        idCardBackUrl: "", //身份证反面
        idCardFrontUrl: "", //身份证正面
        idCardNo: "", //身份证号码
        headImgUrl: "", //身份证头像
        joinTime: new Date() //入职时间
        //roleIdList: '',
      },
      paramsId: 0,
      srcList: []
      //attachmentList: [],
    };
  },
  mixins: [minxin],
  components: {
    drawer
  },

  computed: {},

  created() {
    this.form.headImgUrl = "";
    this.init();
  },
  methods: {
    handleClick(url) {
      for (let i in this.srcList) {
        if (this.srcList[i] == url) {
          this.srcList.splice(i, 1);
        }
      }
      this.srcList.unshift(url);
    },
    init() {
      this.$on("set", function(id) {
        Object.assign(this.$data, this.$options.data());
        this.paramsId = id;
        this.addEditTitle = "店员资料";
        this.$api.get(this.$url.companyShopStaff.get, { id: id }).then(res => {
            if (res) {
                this.form = res;
                if (this.form.headImgUrl == null) {
                    this.form.headImgUrl = "";
                }
                this.srcList.push(this.form.idCardFrontUrl);
                this.srcList.push(this.form.idCardBackUrl);
                this.srcList.push(this.form.headImgUrl);
                this.form.joinTime = this.formatDay(this.form.joinTime);
            }
            this.addEditShow = true;
        });
      });
    },

    handleChangeDrawer(val) {
      this.addEditShow = false;
    },
    back () {
        this.addEditShow = false;
    }
    // 保存
  }
};
</script>
<style lang='less' scoped>
@import "../../../assets/css/edit.less";
.img {
  width: 80px;
  height: 80px;
}
/deep/ .el-input--small .el-input__inner {
  width: 200px;
  height: 40px;
  line-height: 40px;
}
/deep/ div .el-form-item--small .el-form-item__content,
.el-form-item--small .el-form-item__label {
  line-height: 40px;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 200px;
}
.pay-mains {
  padding: 20px;
  .el-form-item {
      margin-bottom: 0;
  }
}
</style>
